import { createContext } from 'react';

const defaultValue = {
  toggle: false,
  handleOpen: () => {},
  handleClose: () => {},
  activeStep: 0,
  handleNext: () => {},
  handleBack: () => {},
  contactData: null,
  setContactData: () => {},
  addressData: null,
  setAddressData: () => {},
  vehicleData: null,
  setVehicleData: () => {},
  serviceData: null,
  setServiceData: () => {},
  couponCode: null,
  setCouponCode: () => {},
  customDiscountReason: null,
  setCustomDiscountReason: () => {},
  customDiscountAmount: null,
  setCustomDiscountAmount: () => {},
  scheduleData: null,
  setScheduleData: () => {},
  savedData: null,
  setSavedData: () => {},
  note: '',
  setNote: () => {},
  loadingDates: false,
  setLoadingDates: () => {},
  isRecurring: false,
  setIsRecurring: () => {},
  rruleAttributes: {},
  rruleCombined: null,
  isEndDateInvalid: false,
  datesToCreate: [],
  setDatesToCreate: () => {},
  unavailableRecurringDates: [],
  setUnavailableRecurringDates: () => {},
  recurringDatesWithConflicts: [],
  setRecurringDatesWithConflicts: () => {},
  conflictReason: null,
  setConflictReason: () => {},
  isUsingOptimalSchedule: true,
  setIsUsingOptimalSchedule: () => {},
  isLoadingAdditionalDates: false,
  setIsLoadingAdditionalDates: () => {},
  isFirstAddressRender: true,
  setIsFirstAddressRender: () => {},
  timeSlotOptions: [],
  setTimeSlotOptions: () => {},
  selectedTimeSlot: '',
  setSelectedTimeSlot: () => {},
  availableDatesToShow: null,
  setAvailableDatesToShow: () => {},
  quoteId: null,
  setQuoteId: () => {},
};

export const QuickAppointmentContext = createContext(defaultValue);
export const QuickAppointmentProvider = QuickAppointmentContext.Provider;
export const QuickAppointmentConsumer = QuickAppointmentContext.Consumer;
